import { FC, useCallback, useEffect } from 'react';
import WebhooksList from './containers/WebhooksList/WebhooksList';
import { webhooksStore } from './store';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { history } from '~/services/history';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import Headers from '~/view/containers/Headers/Headers';

const WebhooksScreen: FC = (): JSX.Element => {
  useEffect(() => {
    return () => webhooksStore.clearFilters();
  }, []);

  const onCreate = useCallback(() => {
    history.push(SCREENS.SETTINGS_WEBHOOK_CREATE());
  }, []);

  return (
    <div className="d-flex flex-column flex-1">
      <Headers>
        <HeaderBack title="webhook" path={SCREENS.SETTINGS()} isBeta />
      </Headers>

      <div className="d-flex flex-row justify-content-end mt-6 mr-4">
        <Button title={localeStore.t('create_webhook')} onClick={onCreate} />
      </div>

      <WebhooksList />
    </div>
  );
};

export default WebhooksScreen;
